if (!customElements.get('video-component')) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.setVideoSrc();
      this.playButton = this.querySelector(".video-play-pause");
      if (this.playButton)
        this.playButton.addEventListener("click", this.videoPlayPause.bind(this));

      if (this.video.getAttribute('autoplay') === null) {
        document.addEventListener('click', (event) => {
          let isClickInside = event.target === this || this.contains(event.target);
          if (!isClickInside) {
            if (this.video.paused !== true) {
              this.video.pause();
              this.video.currentTime = 0;
            }
          }
        });
      }

      this.video.addEventListener('pause', (event) => {
        if (this.playButton)
          this.playButton.classList.add("paused");
        this.classList.remove("playing");
      });
      this.video.addEventListener('play', (event) => {
        if (this.playButton)
          this.playButton.classList.remove("paused");
        this.classList.add("playing");
      });

      if (this.dataset.fullscreen) {
        this.setFullscreenPlayPause();
      }
    }

    setFullscreenPlayPause() {
      this.video.muted = true;
      let playPromise = this.video.play();
      if (playPromise !== undefined) {
        playPromise.then((_) => {
          let observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (
                  !entry.isIntersecting &&
                  !this.video.paused
                ) {
                  this.video.pause();
                  this.video.muted = true;
                } else if (this.video.paused && entry.isIntersecting) {
                  this.video.muted = false;
                  this.video.play();
                }
              });
            },
            { threshold: 0.2 }
          );
          observer.observe(this.video);
        });
      }
    }

    setVideoSrc() {
      const screenWidth = this.getScreenWidth();
      let videoSize = "small";
      if (screenWidth > 1200) {
        videoSize = "wide";
      } else if (screenWidth > 960) {
        videoSize = "medium";
      }
      let videoSrc = this.video.getAttribute(`data-src-${videoSize}`);
      if (!videoSrc || videoSrc === '')
        videoSrc = this.video.getAttribute(`data-src`);
      if (videoSrc && videoSrc !== '')
        this.video.innerHTML = `<source type="video/mp4" src="${videoSrc}" />` + this.video.innerHTML;
    }

    getScreenWidth() {
      return Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      );
    }

    videoPlayPause() {
      if (this.video.paused === true) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }
  }

  customElements.define('video-component', VideoComponent);
}

